<gtin-global-loader></gtin-global-loader>
<router-outlet></router-outlet>
